import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../../../config/end-points";
import useHttp from "../../../../hooks/use-http";
import { settingAction } from "../../../../store/setting-store";
import { cuteToast } from "../../../UI/cute";
import { FiKey, FiCheck } from "react-icons/fi";

const GetResponse = () => {
  const [apiKeys, setApiKeys] = useState({
    gr_key: "",
  });
  const [status, setStatus] = useState(false);

  const is_autoresponder_loaded = useSelector(
    (state) => state.settings.is_autoresponder_loaded
  );
  const autoresponder_keys = useSelector(
    (state) => state.settings.autoresponder
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (is_autoresponder_loaded) {
      const getresponse = autoresponder_keys.filter(
        ({ meta_key }) => meta_key === "getresponse"
      );

      if (getresponse.length > 0) {
        setApiKeys(JSON.parse(getresponse[0].meta_data));
        setStatus(getresponse[0].status === 1 ? true : false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_autoresponder_loaded]);

  const { sendRequest } = useHttp();

  const validateKey = () => {
    sendRequest(
      {
        url: endPoints.validateGetresponse,
        method: "POST",
        body: {
          gr_key: apiKeys.gr_key,
        },
      },
      (response) => {
        if (response.message === "Invalid Keys") {
          cuteToast({
            type: "error",
            message: response.message,
            timer: 5000,
            title: "Error",
          });
        } else {
          sendRequest(
            {
              url: endPoints.insertAutoresponderkeys,
              method: "POST",
              body: {
                meta_key: "getresponse",
                meta_data: apiKeys,
              },
            },
            (response) => {
              if (response.status === 200) {
                cuteToast({
                  type: "success",
                  message: response.message,
                  timer: 5000,
                  title: "success",
                });

                dispatch(
                  settingAction.setAutoresponderStatus({ status: false })
                );
              }
            }
          );
        }
      }
    );
  };

  const disconnectResponder = () => {
    sendRequest(
      {
        url: endPoints.disconnectResponder,
        method: "POST",
        body: {
          meta_key: "getresponse",
        },
      },
      (response) => {
        dispatch(settingAction.setAutoresponderStatus({ status: false }));
      }
    );
  };

  return (
    <div>
      {!status && (
        <>
          <div className="st-form-group">
            <label className="st-label">API Key</label>
            <div className="st-input-wrapper">
              <span className="st-input-icon"><FiKey /></span>
              <input
                type="text"
                className="st-input st-input-with-icon"
                placeholder="Enter GetResponse API Key"
                value={apiKeys.gr_key}
                onChange={(e) =>
                  setApiKeys({ ...apiKeys, gr_key: e.target.value })
                }
              />
            </div>
            <p className="st-helper-text">Access this in Menu {' > '} Integrations & API {' > '} API</p>
          </div>
          <div className="st-form-actions" style={{ justifyContent: "center", paddingTop: "8px" }}>
            <button className="st-btn-primary" type="button" onClick={validateKey}>
              Connect GetResponse
            </button>
          </div>
        </>
      )}

      {status && (
        <div className="st-disconnect-wrap">
          <div className="st-connected-info">
            <div className="st-connected-icon">
              <FiCheck />
            </div>
            <div className="st-connected-details">
              <span className="st-connected-label">GetResponse Account</span>
              <div className="st-connected-status-text">
                <span className="st-status-dot" />
                Active Connection
              </div>
            </div>
            <button className="st-btn-danger" type="button" onClick={disconnectResponder} style={{ padding: "8px 16px", fontSize: "13px" }}>
              Disconnect
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GetResponse;
